module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'projectTermJobs',
    },

    methods: {
        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            fieldData = fieldData || {}
            let $resetAutoComplete
            if(fieldData.fieldCode === 'contractorID' && fieldData.fieldValue){
                $resetAutoComplete = this.$.find('[data-field-code="employeeID"]')
            } else if(fieldData.fieldCode === 'employeeID' && fieldData.fieldValue){
                $resetAutoComplete = this.$.find('[data-field-code="contractorID"]')
            }

            if(($resetAutoComplete || {}).length > 0){
                const resetAutoComplete = getComponent($resetAutoComplete)
                if(resetAutoComplete){
                    resetAutoComplete.unChoose()
                }
            }
        },
    },
}